export const dialog = {
  paper: {
    margin: '1.25rem 1rem',
  },
  paperScrollPaper: {
    maxHeight: 'calc(100% - 2.5rem)',
    width: 'calc(100% - 2rem)',
  },
};
